import moment from 'moment'
/* Format Date "DD/MM/YYYY" */
export function formatDate (date) {
    return moment(date).format('DD/MM/YYYY');
}
export function formatDateHour (date) {
    return moment(date).format('DD/MM/YYYY hh:mm');
}

export function formatDateToHTML5 (date) {
    return moment(date).format('YYYY-MM-DD');
}


// WEBPACK FOOTER //
// ./src/filters/formatDate.js